/**
 * @generated SignedSource<<2792680faa99c771bbe561d352bc75cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BuildDependantsQuery$variables = {
  buildLocator: string;
};
export type BuildDependantsQuery$data = {
  readonly build: {
    readonly related: {
      readonly builds: {
        readonly count: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type BuildDependantsQuery = {
  response: BuildDependantsQuery$data;
  variables: BuildDependantsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "buildLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buildLocator",
    "variableName": "buildLocator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Related",
  "kind": "LinkedField",
  "name": "related",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "locator",
          "value": "count:1,defaultFilter:false,item:(count:1,defaultFilter:false,snapshotDependency:(from:(id:$context.build.id),recursive:false)),item:(count:1,defaultFilter:false,state:finished,artifactDependency:(from:(id:$context.build.id),recursive:false))"
        }
      ],
      "concreteType": "Builds",
      "kind": "LinkedField",
      "name": "builds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": "builds(locator:\"count:1,defaultFilter:false,item:(count:1,defaultFilter:false,snapshotDependency:(from:(id:$context.build.id),recursive:false)),item:(count:1,defaultFilter:false,state:finished,artifactDependency:(from:(id:$context.build.id),recursive:false))\")"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildDependantsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "build",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BuildDependantsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "build",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2af8e92c6d67d9a7f10d2a42e8325ac2",
    "id": null,
    "metadata": {},
    "name": "BuildDependantsQuery",
    "operationKind": "query",
    "text": "query BuildDependantsQuery(\n  $buildLocator: String!\n) {\n  build(buildLocator: $buildLocator) {\n    related {\n      builds(locator: \"count:1,defaultFilter:false,item:(count:1,defaultFilter:false,snapshotDependency:(from:(id:$context.build.id),recursive:false)),item:(count:1,defaultFilter:false,state:finished,artifactDependency:(from:(id:$context.build.id),recursive:false))\") {\n        count\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8c0e521cade98d97b88db91dc1105f78";

export default node;
